import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

import { RoutingRuleconfig1Component } from './routing-ruleconfig1.component';
import { RoutingPipelineLeftPanelComponent } from './components/routing-pipeline-left-panel/routing-pipeline-left-panel.component';
import { RoutingRulesRightPanelComponent } from './components/routing-rules-right-panel/routing-rules-right-panel.component';
import { BuildFieldPathDialogComponent } from './dialogs/build-field-path-dialog.component';

@NgModule({
  declarations: [
    RoutingRuleconfig1Component,
    RoutingPipelineLeftPanelComponent,
    RoutingRulesRightPanelComponent,
    BuildFieldPathDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatChipsModule,
    AutocompleteLibModule,
    MonacoEditorModule,
  ],
  exports: [RoutingRuleconfig1Component],
})
export class RoutingRuleconfig1Module {}
